import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AwsAuthService {

  public isUserLoggedIn: boolean = false;
  public code: any;

  private readonly _loginStatusSubject = new BehaviorSubject<boolean>(false);
  public disableMultipleClicks: boolean = false;

  constructor(private readonly _httpClient: HttpClient, private readonly _route: ActivatedRoute) {
    this.getAuthCode();
  }

  public signIn(): Observable<any> {
    const userCountry: {code: string, region: string} | any = JSON.parse(localStorage.getItem('countryOfOrigin') ?? "{code: 'DE', region: 'ece'}")
    const url = environment.proxyEndpoint + '/auth/federatedSignIn?country='+userCountry.code+'&region='+userCountry.region;
    return this._httpClient.get<any>(url);
  }

  public manageLoginResponse(): void {
    if (this.disableMultipleClicks) {
      return;
    }

    this.disableMultipleClicks = true;

    this.signIn().subscribe((response: any) => {
      window.location.href = response.loginUrl;
      setTimeout(() => {
        this.disableMultipleClicks = false;
      }, 3000);
    })
  }

  public getAuthCode(): void {
    this._route?.queryParams?.subscribe((params: { [x: string]: any; }) => {
      this.code = params['code'];
      if (this.code) {
        this.callGenerateAuthTokenApi(this.code).subscribe(response => {
          if (response) {
            this.disableMultipleClicks = false;
            this.setUserLoggedInStatus();
            const responseBody = response.body
            this.isLoginSucess = responseBody.success
          }
        });
      }
    });
  }

  public callGenerateAuthTokenApi(code: any): Observable<any> {
    const url = `${environment.proxyEndpoint}/auth/token?code=${code}`;
    return this._httpClient.get<any>(url, {observe: 'response', withCredentials: true});
  }

  public logout() {
    this.clearLocalStorageItems();
    const url = environment.proxyEndpoint + '/auth/signout';
    return this._httpClient.get<any>(url);
  }

  public manageLogoutResponse(): void {
    this.logout().subscribe((response: any) => {
      window.location.href = response.logout_uri
    });
  }

  public setUserLoggedInStatus(): void {
    localStorage.setItem('isLoggedIn', 'true');
  }

  public getUserLoggedInStatus(): boolean {
    return localStorage.getItem('isLoggedIn') === 'true' || false;
  }

  public clearLocalStorageItems() {
    localStorage.removeItem('isBasicAuthSuccess');
    localStorage.removeItem('isLoggedIn');
  }

  public set isLoginSucess(success: boolean) {
    this._loginStatusSubject.next(success);
  }

  public get isLoginSuccess() {
    return this._loginStatusSubject.asObservable();
  }

}
